import { MotiView } from "moti";
import React from "react";

import { Box } from "@whoosh/design-system/src/components/primitive";

import { WhooshCrownIcon } from "../../icons_v2/general";
import { useRegisterLoaderActivity } from "./LoaderActivityContext";

export { LoaderActivityProvider } from "./LoaderActivityContext";

export const Loader = () => {
  useRegisterLoaderActivity();

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      bottom={0}
      right={0}
      alignItems="center"
      justifyContent="center"
      zIndex={100}
      testID="universal-whoosh-crown-loader"
    >
      <Box
        position="absolute"
        top={0}
        left={0}
        opacity={40}
        bottom={0}
        right={0}
        zIndex={10}
      />
      <MotiView
        from={{
          scale: 0.7,
        }}
        animate={{
          scale: 1,
        }}
        transition={{
          scale: {
            loop: true,
            type: "timing",
            duration: 1500,
            delay: 0,
          },
        }}
        style={{
          zIndex: 20,
          flexGrow: 1,
          width: "100%",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <WhooshCrownIcon color="grayscale-1000" width={100} height={100} />
      </MotiView>
    </Box>
  );
};
